
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wines/[...slug]",
      function () {
        return require("private-next-pages/wines/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wines/[...slug]"])
      });
    }
  